<template>
  <parallax-container class="container-2" v-if="this.$mq !== 'mobile'">
    <parallax-element :parallaxStrength="15" :type="'translation2'" class="left"></parallax-element>
    <parallax-element :parallaxStrength="15" :type="'translation2'" class="right"></parallax-element>
  </parallax-container>
</template>

<script>
    import parallaxContainer from "../parallax/parallax-container.vue";
    import parallaxElement from "../parallax/parallax-element.vue";

    export default {
        name: "CurtainsIndex",
        components: {
            parallaxContainer,
            parallaxElement,

        }
    }
</script>

<style scoped lang="scss">
  .container-2 {
    top: 0;
    left: 0;
    width: 100%;
    height: 85%;
    position: absolute;
    overflow: hidden;
    z-index: 1;
  }

  .left {
    position: absolute;
    height: 104%;
    top: -2%;
    left: -7%;
    background-image: url("../../assets/images/curtains/index/lines_left.svg");
    background-size: cover;
    width: 30%;
    z-index: 200;
  }

  .right {
    position: absolute;
    height: 104%;
    top: -2%;
    right: -7%;
    background-image: url("../../assets/images/curtains/index/lines_right.svg");
    background-size: cover;
    width: 30%;
    z-index: 200;
  }


</style>